import { HttpInterceptor, HttpEvent, HttpRequest, HttpResponse, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie';
import { Constant } from '../../shared/constant';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

    constructor(private cookieService: CookieService) {
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const  xsrfCookieValue = this.TokenValue;

        var request = req.clone({ setHeaders: { 'X-XSRF-TOKEN' : xsrfCookieValue['X-XSRF-TOKEN'] as string } });
        return next.handle(request).pipe(
            tap(
              evt => {
                if (evt instanceof HttpResponse) {
                  if ('ok' in evt && evt.ok) {
                    if (evt.headers.get('X-XSRF-TOKEN') != null) {
                      let XSRF = evt.headers.get('X-XSRF-TOKEN') as string
                      this.cookieService.put('XSRF-TOKEN', XSRF, { domain: '.atitesting.com' });
                    }                   
                  }
                }
              }      
            )
          );
    }

    get TokenValue(){
       const xsrfCookieValue =  { 'X-XSRF-TOKEN' : this.cookieService.get(Constant.XSRFTOKENCookieName)};
       if (!xsrfCookieValue['X-XSRF-TOKEN']) {
            xsrfCookieValue['X-XSRF-TOKEN'] = ''; 
        }
        return xsrfCookieValue;
    }

}
